const DefaultVariant = require('./default')
const CheckAvailabilityVariant = require('./check-availability')
const RoomList = require('./room-list')
const RoomDetail = require('./room-detail')
const BookingRoomList = require('./booking-room-list')
const BookingRateList = require('./booking-rate-list')
const HotelsList = require('./hotels-list')
const CurrencyList = require('./currency-list')
const GenericSearchList = require('./generic-search-list')
const MyStaysList = require('./my-stays-list')
const ExperincesList = require('./experience-list')
const ExperincesListScrollable = require('./experience-list-scrollable')
const MenuList2Columns = require('./menu-list-2columns')
const MenuList3Columns = require('./menu-list-3columns')
const UpcomingEventsList = require('./upcoming-events')
const TreatmentsList = require('./treatments-list')
const RestaurantList = require('./restaurant-list')

const lists = {
  [DefaultVariant.name]: DefaultVariant,
  [CheckAvailabilityVariant.name]: CheckAvailabilityVariant,
  [RoomList.name]: RoomList,
  [RoomDetail.name]: RoomDetail,
  [BookingRoomList.name]: BookingRoomList,
  [BookingRateList.name]: BookingRateList,
  [HotelsList.name]: HotelsList,
  [CurrencyList.name]: CurrencyList,
  [GenericSearchList.name]: GenericSearchList,
  [MyStaysList.name]: MyStaysList,
  [ExperincesList.name]: ExperincesList,
  [ExperincesListScrollable.name]: ExperincesListScrollable,
  [MenuList2Columns.name]: MenuList2Columns,
  [MenuList3Columns.name]: MenuList3Columns,
  [UpcomingEventsList.name]: UpcomingEventsList,
  [TreatmentsList.name]: TreatmentsList,
  [RestaurantList.name]: RestaurantList,
}

module.exports = {
  lists
}
